module.exports = __webpack_public_path__ + "assets/total_conversion_values.249939c1.svg";